/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AuctionWithTranslationsPartial } from '../../models/auction-with-translations-partial';

export interface InventoryUpdateAuction$Params {
  id: string;
  inventoryId: string;
      body?: AuctionWithTranslationsPartial
}

export function inventoryUpdateAuction(http: HttpClient, rootUrl: string, params: InventoryUpdateAuction$Params, context?: HttpContext): Observable<StrictHttpResponse<any>> {
  const rb = new RequestBuilder(rootUrl, inventoryUpdateAuction.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.query('inventoryId', params.inventoryId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<any>;
    })
  );
}

inventoryUpdateAuction.PATH = '/inventory/auctions/{id}';
